






































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as ui from '../../ui';
import T from '../../lang';
import { dao, types } from '../../api_types';
import user_ProfileWrapper from './ProfileWrapper.vue';
import user_ViewProfile from './ViewProfile.vue';
import user_PreferencesEdit from './PreferencesEdit.vue';
import user_BasicInformationEdit from './BasicInformationEdit.vue';
import user_PasswordEdit from './PasswordEdit.vue';
import user_PasswordAdd from './PasswordAdd.vue';
import { urlMapping } from './SidebarMainInfo.vue';
import user_ManageSchools from './ManageSchools.vue';
import user_ManageIdentities from './ManageIdentities.vue';
import user_ManageApiTokens from './ManageApiTokens.vue';
import userDeleteAccount from './DeleteAccount.vue';

@Component({
  components: {
    'omegaup-user-profile-wrapper': user_ProfileWrapper,
    'omegaup-user-view-profile': user_ViewProfile,
    'omegaup-user-edit-preferences': user_PreferencesEdit,
    'omegaup-user-edit-basic-information': user_BasicInformationEdit,
    'omegaup-user-edit-password': user_PasswordEdit,
    'omegaup-user-add-password': user_PasswordAdd,
    'omegaup-user-manage-identities': user_ManageIdentities,
    'omegaup-user-manage-api-tokens': user_ManageApiTokens,
    'omegaup-user-manage-schools': user_ManageSchools,
    'omegaup-user-delete-account': userDeleteAccount,
  },
})
export default class Profile extends Vue {
  @Prop({ default: null }) data!: types.ExtraProfileDetails | null;
  @Prop() profile!: types.UserProfileInfo;
  @Prop({ default: 'view-profile' }) selectedTab!: string;
  @Prop({ default: null }) viewProfileSelectedTab!: string | null;
  @Prop() identities!: types.Identity[];
  @Prop() apiTokens!: types.ApiToken[];
  @Prop() profileBadges!: Set<string>;
  @Prop() visitorBadges!: Set<string>;
  @Prop() countries!: dao.Countries[];
  @Prop() programmingLanguages!: { [key: string]: string };
  @Prop() hasPassword!: boolean;
  @Prop() searchResultSchools!: types.SchoolListItem[];
  @Prop({ default: () => [] }) heatmapData!: Array<{
    date: string;
    count: number;
  }>;
  @Prop({ default: () => [] }) availableYears!: number[];

  T = T;
  ui = ui;
  currentSelectedTab = this.selectedTab;
  currentViewProfileSelectedTab = this.viewProfileSelectedTab;

  get currentTitle(): string {
    if (!this.profile.is_own_profile) {
      return T.omegaupTitleProfile;
    }
    return (
      urlMapping.find((url) => url.key === this.currentSelectedTab)?.title ??
      'view-profile'
    );
  }

  @Watch('selectedTab')
  onSelectedTabChanged(newValue: string) {
    this.currentSelectedTab = newValue;
  }
}
